<template>
    <div class="shortcut-container">
        <div v-if="props.data?.length">
            <ul
                class="shortcut-list"
                :class="{'active': currentStatus === 'open'}">
                <li
                    class="shortcut-item pointer"
                    v-for="item in showList"
                    :key="item.id"
                    :style="{'background-image': `url(${item.quickIcon?.iconPath})` }"
                    v-link="item.clickUrl"
                    @click="goDetail(item)">
                    <p
                        class="text overflow-ellipsis"
                        :title="item.contentTitle"
                        :style="{'color':item.quickIcon?.textColor }">{{item.contentTitle || ''}}</p>
                </li>
                <li class="see-more flex-center pointer" @click="handleOpen" v-if="props.data.length > 4">
                    <el-icon :class="{ 'handstand': currentStatus === 'open' }"><CaretBottom /></el-icon>
                </li>
            </ul>
        </div>
        <BigNoData
            class="mar-top49"
            v-else
            url="no-shortcut@2x.png"
            info="一大波快捷入口正在策划中…"/>
    </div>
</template>

<script setup>
import BigNoData from '@/components/no-data.vue';
import { ref, computed } from 'vue';
import { pageJump } from '@/global/location-transfer';
import { CaretBottom } from '@element-plus/icons-vue';

const props = defineProps({
    data: { // 快捷入口列表
        type: Array,
        default: () => []
    }
})

const emit = defineEmits(['get-list']);

// 快捷入口设置
let currentStatus = ref('close');

// 切换显示更多或者默认显示四条 最多展示10条
function handleOpen () {
    if (props.data.length > 4) {
        currentStatus.value = currentStatus.value === 'open' ? 'close' : 'open';
    }
}

// 显示的快捷入口的列表
let showList = computed(() => {
    return currentStatus.value === 'open' ? props.data : props.data.slice(0, 4);
})

// 跳转快捷入口详情
function goDetail (item) {
    pageJump(item.clickUrl, true);
}
</script>

<style lang="scss" scoped>
.shortcut-container {
    width: 100%;
    position: relative;
    margin-top: 16px;
    .shortcut-list {
        width: calc(100% + 20px);
        position: absolute;
        left: -10px;
        background-color: #ffffff;
        z-index: 2;
        padding-top: 10px;
        padding: 10px;
        .shortcut-item {
            display: flex;
            align-items: center;
            width: 100%;
            height: 38px;
            margin-bottom: 10px;
            background-size: contain;
            .img {
                width: 22px;
                height: 22px;
                margin: 0 12px 0 20px;
            }
            .text {
                font-size: 16px;
                font-weight: bold;
                padding-right: 10px;
                margin-left: 54px;
            }
        }
        .see-more {
            height: 16px;
            line-height: 1;
            background: #f7f9fA;
            border-radius: 4px;
            font-size: 18px;
            color: var(--home-main-color);
            .handstand {
                transform: rotate(180deg);
            }
        }
        &.active {
            box-shadow: 0px 3px 3px 0px rgba(156, 166, 157, 0.3);
            border-radius: 4px;
            // transition: box-shadow 0.3s;
        }
    }
    .mar-top49 {
        margin-top: 49px;
    }
}
</style>